// extracted by mini-css-extract-plugin
export var content = "_96-3";
export var list = "_96-4";
export var settingsContent = "_96-7";
export var settingsPanel = "_96-8";
export var state = "_96-6";
export var triggerBadge = "_96-2";
export var triggerButton = "_96-1";
export var triggerShell = "_96-0";
export var unreadDot = "_96-5";